import Paper from "@mui/material/Paper";
import { ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import { Link } from "react-router-dom";
import BodyText from "../../../components/BodyText";
import SubTitle from "../../../components/SubTitle";
import appLogoImg from "../../../assets/cosmo-app-logo.png";
import qrAppStoreImg from "../../../assets/app-store-qr.png";
import qrGoogePlayImg from "../../../assets/google-play-qr.png";
import appPhoneImg from "../../../assets/cosmo-app-phone.png";
import styles from "./AppInfoCard.module.css";

const AppInfoCard = () => (
  <Paper
    sx={{
      width: 800,
      borderRadius: 5,
      display: { md: "flex", xs: "none" },
      flexDirection: "row",
      px: "2%",
      py: "30px",
      position: "relative",
      my: "20px",
    }}
    elevation={3}
  >
    <div>
      <BodyText>Next Step</BodyText>
      <SubTitle>Download the App</SubTitle>
      <ListItem sx={{ pl: 0 }}>
        <ListItemAvatar sx={{ mr: "11px", display: "flex", pt: "2px" }}>
          <img src={appLogoImg} alt="Cosmo App Logo" />
        </ListItemAvatar>
        <ListItemText
          primary="Cosmo: Mission Control"
          secondary="The app for parental control"
          primaryTypographyProps={{ sx: { fontWeight: 600 } }}
        />
      </ListItem>
      <div className={styles.qr_div}>
        <img src={qrGoogePlayImg} alt="QR code for Cosmo App on Google Play" className={styles.qr_img} />
        <img src={qrAppStoreImg} alt="QR code for Cosmo App on App Store" className={styles.qr_img} />
      </div>
      <BodyText>
        Or
        {" "}
        <Link to="/" reloadDocument>
          activate another device
        </Link>
      </BodyText>
    </div>
    <img src={appPhoneImg} alt="Mobile Phone with Cosmo App opened" className={styles.phone_img} />
  </Paper>
);

export default AppInfoCard;
